// @flow
import update from 'immutability-helper';

function sequenceItemsMap(items: *): Map<string, *> {
  return new Map(items.map(item => [item.item.uuid, item]));
}

export function addSequenceItemsToQueryResult(result: *, newSequenceItems: *) {
  const oldItems = sequenceItemsMap(result.entityStreams[0].sequenceItems);
  const newItems = sequenceItemsMap(newSequenceItems);

  const mergedMap = new Map([...oldItems, ...newItems]);
  const mergedArray = Array.from(mergedMap.values());

  const sortedArray = mergedArray.sort((a, b) => {
    if (Number(a.seq) > Number(b.seq)) {
      return -1;
    }

    if (Number(a.seq) < Number(b.seq)) {
      return 1;
    }

    return 0;
  });

  return update(result, {
    entityStreams: {
      '0': { sequenceItems: { $set: sortedArray } },
    },
  });
}
